import {Component, OnInit} from '@angular/core';
import {ComissionamentoService} from '../../services/comissionamento.service';
import {ConstantsService} from '../ConstantsService';

@Component({
  selector: 'app-modulo-comissionamento',
  templateUrl: './modulo-comissionamento.component.html',
  styleUrls: ['./modulo-comissionamento.component.scss']
})
export class ModuloComissionamentoComponent implements OnInit {
  empresa: any;
  catalogoId: number;
  aba = 'comissoes';
  carregando = false;
  carregandoProdutos = false;
  salvando = false;
  erro: string;
  sucesso: string;

  comissoes: any[] = [];
  comissionados: any[] = [];
  produtos: any[] = [];
  produtosResumoComissoes: any[] = [];
  categorias: any[] = [];
  produtosSelecionados: {[key: number]: boolean} = {};

  filtroComissoes: any = {busca: '', status: 'todas'};
  filtroProdutos: any = {busca: '', categoriaId: null};
  filtrosCadastro: any = {incluirComissoesInativas: false, incluirComissionadosInativos: false};
  filtroRelatorio: any = this.novoFiltroRelatorio();

  labelComissionados = 'Comissionados';
  comissaoSelecionada: any;
  comissaoEdicao: any = this.novaComissao();
  comissionadoEdicao: any = this.novoComissionado();
  comissionadoRapido: any = this.novoComissionado();
  buscaComissionadoRapido = '';
  modalComissaoAberto = false;
  modalProdutosAberto = false;
  modalDetalhesRelatorioAberto = false;
  modoProdutos: 'vinculados' | 'adicionar' = 'vinculados';
  relatorio: any[] = [];
  comissionadoDetalheRelatorio: any;
  relatorioDetalheSelecionado: any[] = [];
  carregandoRelatorio = false;
  private resumoComissionadoRelatorioRef: any[];
  private resumoComissionadoStatusRef: string;
  private resumoComissionadoCache: any[] = [];

  constructor(private service: ComissionamentoService, private constantsService: ConstantsService) { }

  ngOnInit() {
    this.constantsService.empresa$.subscribe((empresa) => {
      this.empresa = empresa;
      this.catalogoId = empresa?.catalogo?.id;
      this.labelComissionados = empresa?.comissionadoLabel || 'Comissionados';
      this.categorias = this.obtenhaCategoriasCatalogo(empresa?.catalogo?.categorias || []);
      if(this.catalogoId)
        this.carregueTudo();
    });
  }

  carregueTudo() {
    this.carregueComissoes();
    this.carregueComissionados();
    this.carregueResumoProdutosComissoes();
  }

  selecioneAba(aba: string) {
    this.aba = aba;
    this.limpeMensagens();
    this.modalProdutosAberto = false;

    if(aba === 'relatorio')
      this.carregueRelatorio();
  }

  carregueComissoes() {
    this.carregando = true;
    this.filtrosCadastro.incluirComissoesInativas = this.filtroComissoes.status !== 'ativas';
    this.service.listeComissoes({incluirInativas: this.filtrosCadastro.incluirComissoesInativas}).then((comissoes: any[]) => {
      this.comissoes = comissoes || [];
      if(!this.comissaoSelecionada && this.comissoes.length)
        this.comissaoSelecionada = this.comissoes[0];
      if(this.comissaoSelecionada && !this.comissoes.some((item) => item.id === this.comissaoSelecionada.id))
        this.comissaoSelecionada = this.comissoes[0] || null;
      this.carregando = false;
    }).catch((erro) => this.trateErro(erro));
  }

  carregueResumoProdutosComissoes() {
    if(!this.catalogoId)
      return;

    this.service.listeProdutos({catalogoId: this.catalogoId}).then((produtos: any[]) => {
      this.produtosResumoComissoes = produtos || [];
    }).catch(() => {
      this.produtosResumoComissoes = [];
    });
  }

  carregueComissionados() {
    this.service.listeComissionados({incluirInativos: this.filtrosCadastro.incluirComissionadosInativos}).then((comissionados: any[]) => {
      this.comissionados = comissionados || [];
    }).catch((erro) => this.trateErro(erro));
  }

  salveLabelComissionados() {
    this.salvando = true;
    this.labelComissionados = this.labelOperacionalPlural();
    this.service.atualizeLabel(this.labelComissionados).then((dados: any) => {
      this.labelComissionados = dados?.comissionadoLabel || this.labelComissionados || 'Comissionados';
      if(this.empresa)
        this.empresa.comissionadoLabel = this.labelComissionados;
      this.sucesso = 'Nome operacional salvo.';
      this.salvando = false;
    }).catch((erro) => this.trateErro(erro));
  }

  carregueProdutos() {
    if(!this.catalogoId)
      return;

    if(this.modoProdutos === 'vinculados' && !this.comissaoSelecionada?.id) {
      this.produtos = [];
      this.produtosSelecionados = {};
      return;
    }

    this.carregandoProdutos = true;
    const filtro: any = {
      catalogoId: this.catalogoId,
    };

    if(this.modoProdutos === 'vinculados' && this.comissaoSelecionada?.id) {
      filtro.comissaoId = this.comissaoSelecionada.id;
    } else {
      filtro.busca = String(this.filtroProdutos.busca || '').trim();
      filtro.categoriaId = this.filtroProdutos.categoriaId || null;
      filtro.disponivelParaComissao = 1;
    }

    this.service.listeProdutos(filtro).then((produtos: any[]) => {
      this.produtos = produtos || [];
      if(this.modoProdutos !== 'vinculados' && !this.categorias.length && !filtro.busca && !filtro.categoriaId)
        this.categorias = this.obtenhaCategorias(this.produtos);
      this.produtosSelecionados = {};
      this.carregandoProdutos = false;
    }).catch((erro) => this.trateErro(erro));
  }

  editeComissao(comissao: any) {
    this.comissaoEdicao = {...comissao};
    this.comissaoSelecionada = comissao;
    this.modalComissaoAberto = true;
    this.selecioneAba('comissoes');
  }

  abraNovaComissao() {
    this.comissaoEdicao = this.novaComissao();
    this.modalComissaoAberto = true;
    this.limpeMensagens();
  }

  fecheModalComissao() {
    this.modalComissaoAberto = false;
    this.comissaoEdicao = this.novaComissao();
  }

  abraProdutosDaComissao(comissao: any) {
    this.comissaoSelecionada = comissao;
    this.filtroProdutos = {busca: '', categoriaId: null};
    this.produtosSelecionados = {};
    this.modoProdutos = 'vinculados';
    this.modalProdutosAberto = true;
    this.limpeMensagens();
    this.carregueProdutos();
  }

  fecheModalProdutos() {
    this.modalProdutosAberto = false;
    this.produtosSelecionados = {};
  }

  abraAdicionarProdutos() {
    this.modoProdutos = 'adicionar';
    this.produtosSelecionados = {};
    this.carregueProdutos();
  }

  volteProdutosVinculados() {
    this.modoProdutos = 'vinculados';
    this.produtosSelecionados = {};
    this.carregueProdutos();
  }

  abraNovoComissionado() {
    this.comissionadoRapido = this.novoComissionado();
    this.buscaComissionadoRapido = '';
  }

  novaComissao() {
    return {nome: '', valorFixo: null, ativo: true};
  }

  salveComissao() {
    this.salvando = true;
    this.service.salveComissao(this.comissaoEdicao).then(() => {
      this.sucesso = 'Comissão salva.';
      this.comissaoEdicao = this.novaComissao();
      this.modalComissaoAberto = false;
      this.salvando = false;
      this.carregueComissoes();
      this.carregueResumoProdutosComissoes();
    }).catch((erro) => this.trateErro(erro));
  }

  removaComissao(comissao: any) {
    this.service.removaComissao(comissao).then(() => {
      this.sucesso = 'Comissão removida.';
      if(this.comissaoSelecionada?.id === comissao.id)
        this.comissaoSelecionada = null;
      this.carregueComissoes();
      this.carregueResumoProdutosComissoes();
    }).catch((erro) => this.trateErro(erro));
  }

  novoComissionado() {
    return {nome: '', ativo: true};
  }

  novoFiltroRelatorio() {
    const hoje = new Date();
    const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1, 0, 0, 0, 0);
    const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59, 999);

    return {
      inicio,
      fim,
      comissionado: null,
      comissao: null,
      status: 'validas',
      incluirCanceladas: false,
      incluirEstornadas: false
    };
  }

  editeComissionado(comissionado: any) {
    this.comissionadoEdicao = {...comissionado};
    this.selecioneAba('comissionados');
  }

  salveComissionado() {
    this.salvando = true;
    this.service.salveComissionado(this.comissionadoEdicao).then(() => {
      this.sucesso = `${this.labelOperacionalSingular()} salvo.`;
      this.comissionadoEdicao = this.novoComissionado();
      this.salvando = false;
      this.carregueComissionados();
    }).catch((erro) => this.trateErro(erro));
  }

  salveComissionadoRapido() {
    this.salvando = true;
    this.service.salveComissionado(this.comissionadoRapido).then(() => {
      this.sucesso = `${this.labelOperacionalSingular()} salvo.`;
      this.comissionadoRapido = this.novoComissionado();
      this.salvando = false;
      this.carregueComissionados();
    }).catch((erro) => this.trateErro(erro));
  }

  removaComissionado(comissionado: any) {
    this.service.removaComissionado(comissionado).then(() => {
      this.sucesso = `${this.labelOperacionalSingular()} removido.`;
      this.carregueComissionados();
    }).catch((erro) => this.trateErro(erro));
  }

  vinculeSelecionados() {
    const ids = this.produtosSelecionadosDoModal();

    if(!this.comissaoSelecionada || !ids.length)
      return;

    this.service.vinculeProdutos(this.comissaoSelecionada.id, this.catalogoId, ids).then(() => {
      this.sucesso = 'Produtos adicionados à comissão.';
      this.produtosSelecionados = {};
      this.carregueProdutos();
      this.carregueComissoes();
      this.carregueResumoProdutosComissoes();
    }).catch((erro) => this.trateErro(erro));
  }

  vinculeProduto(produto: any) {
    if(!this.comissaoSelecionada || !produto?.id)
      return;

    this.service.vinculeProdutos(this.comissaoSelecionada.id, this.catalogoId, [produto.id]).then(() => {
      this.sucesso = 'Produto adicionado à comissão.';
      this.carregueProdutos();
      this.carregueComissoes();
      this.carregueResumoProdutosComissoes();
    }).catch((erro) => this.trateErro(erro));
  }

  vinculeCategoria() {
    if(!this.comissaoSelecionada || !this.filtroProdutos.categoriaId)
      return;

    this.service.vinculeCategoria(this.comissaoSelecionada.id, this.catalogoId, Number(this.filtroProdutos.categoriaId)).then(() => {
      this.sucesso = 'Categoria adicionada à comissão.';
      this.carregueProdutos();
      this.carregueComissoes();
      this.carregueResumoProdutosComissoes();
    }).catch((erro) => this.trateErro(erro));
  }

  removaProdutoDaComissao(produto: any) {
    this.service.desvinculeProdutos(this.catalogoId, [produto.id], this.comissaoSelecionada?.id).then(() => {
      this.sucesso = 'Produto removido da comissão.';
      this.removaProdutosVinculadosLocalmente([produto.id]);
    }).catch((erro) => this.trateErro(erro));
  }

  removaSelecionadosDaComissao() {
    if(!this.comissaoSelecionada)
      return;

    const ids = this.produtosSelecionadosDoModal()
      .filter((id) => this.produtos.some((produto) => Number(produto.id) === id && this.produtoDaComissaoAtual(produto)));

    if(!ids.length)
      return;

    this.service.desvinculeProdutos(this.catalogoId, ids, this.comissaoSelecionada.id).then(() => {
      this.sucesso = 'Produtos removidos da comissão.';
      this.removaProdutosVinculadosLocalmente(ids);
    }).catch((erro) => this.trateErro(erro));
  }

  carregueRelatorio() {
    this.carregandoRelatorio = true;
    this.fecheDetalhesRelatorio();
    this.apliqueStatusRelatorio();
    const filtro: any = {
      inicio: this.filtroRelatorio.inicio,
      fim: this.filtroRelatorio.fim,
      incluirCanceladas: this.filtroRelatorio.incluirCanceladas,
      incluirEstornadas: this.filtroRelatorio.incluirEstornadas
    };

    if(this.filtroRelatorio.comissionado?.id)
      filtro.comissionadoId = this.filtroRelatorio.comissionado.id;
    if(this.filtroRelatorio.comissao?.id)
      filtro.comissaoId = this.filtroRelatorio.comissao.id;

    this.service.relatorio(filtro).then((relatorio: any[]) => {
      this.relatorio = relatorio || [];
      this.carregandoRelatorio = false;
    }).catch((erro) => this.trateErro(erro));
  }

  altereStatusRelatorio(status: string) {
    this.filtroRelatorio.status = status;
    this.fecheDetalhesRelatorio();
    this.apliqueStatusRelatorio();
  }

  altereInclusaoCanceladasEstornadas(incluir: boolean) {
    this.filtroRelatorio.status = incluir ? 'todos' : 'validas';
    this.fecheDetalhesRelatorio();
    this.apliqueStatusRelatorio();
  }

  incluiCanceladasEstornadas() {
    return this.filtroRelatorio.incluirCanceladas && this.filtroRelatorio.incluirEstornadas;
  }

  limpeFiltroRelatorio() {
    this.filtroRelatorio = this.novoFiltroRelatorio();
    this.carregueRelatorio();
  }

  totalRelatorio() {
    return this.relatorioBase()
      .filter((item) => item.status === 'calculada')
      .reduce((total, item) => total + Number(item.valorCalculado || 0), 0);
  }

  totalRelatorioStatus(status: string) {
    return this.relatorioBase()
      .filter((item) => item.status === status)
      .reduce((total, item) => total + Number(item.valorCalculado || 0), 0);
  }

  totalRelatorioCanceladasEstornadas() {
    return this.totalRelatorioStatus('cancelada') + this.totalRelatorioStatus('estornada');
  }

  totalItensRelatorio() {
    return this.relatorioBase()
      .reduce((total, item) => total + Number(item.quantidade || 0), 0);
  }

  totalComissionadosRelatorio() {
    const mapa: any = {};
    this.relatorioBase().forEach((item) => {
      const chave = item.comissionado?.id || item.nomeComissionado;
      if(chave)
        mapa[chave] = true;
    });
    return Object.keys(mapa).length;
  }

  resumoPorComissionado() {
    const relatorio = this.relatorio || [];
    const status = this.filtroRelatorio.status;
    if(this.resumoComissionadoRelatorioRef === relatorio && this.resumoComissionadoStatusRef === status)
      return this.resumoComissionadoCache;

    const mapa: any = {};
    this.relatorioBase().forEach((item) => {
      const chave = this.chaveComissionadoRelatorio(item);
      const nome = item.nomeComissionado || item.comissionado?.nome || '-';
      if(!mapa[chave]) {
        mapa[chave] = {
          chave,
          id: item.comissionado?.id || null,
          nome,
          itens: 0,
          lancamentos: 0,
          validas: 0,
          canceladas: 0,
          estornadas: 0,
          total: 0
        };
      }

      mapa[chave].lancamentos++;
      mapa[chave].itens += Number(item.quantidade || 0);
      if(item.status === 'calculada') {
        mapa[chave].validas += Number(item.valorCalculado || 0);
        mapa[chave].total += Number(item.valorCalculado || 0);
      }
      if(item.status === 'cancelada')
        mapa[chave].canceladas += Number(item.valorCalculado || 0);
      if(item.status === 'estornada')
        mapa[chave].estornadas += Number(item.valorCalculado || 0);
    });

    this.resumoComissionadoRelatorioRef = relatorio;
    this.resumoComissionadoStatusRef = status;
    this.resumoComissionadoCache = Object.keys(mapa)
      .map((chave) => mapa[chave])
      .sort((a, b) => b.total - a.total || a.nome.localeCompare(b.nome));

    return this.resumoComissionadoCache;
  }

  trackByResumoComissionado(index: number, linha: any) {
    return linha?.chave || index;
  }

  relatorioDetalhado() {
    return this.relatorioBase();
  }

  abraDetalhesRelatorio(linha: any, event?: Event) {
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if(!linha)
      return;

    this.comissionadoDetalheRelatorio = Object.assign({}, linha);
    this.relatorioDetalheSelecionado = this.relatorioDetalhado()
      .filter((item) => this.chaveComissionadoRelatorio(item) === linha.chave);
    this.modalDetalhesRelatorioAberto = true;
  }

  fecheDetalhesRelatorio() {
    this.modalDetalhesRelatorioAberto = false;
    this.comissionadoDetalheRelatorio = null;
    this.relatorioDetalheSelecionado = [];
  }

  relatorioDetalhadoComissionado() {
    if(!this.comissionadoDetalheRelatorio?.chave)
      return this.relatorioDetalhado();

    return this.relatorioDetalheSelecionado || [];
  }

  textoStatusRelatorio(status: string) {
    if(status === 'calculada')
      return 'Calculada';
    if(status === 'cancelada')
      return 'Cancelada';
    if(status === 'estornada')
      return 'Estornada';
    return status || '-';
  }

  classeStatusRelatorio(status: string) {
    return {
      active: status === 'calculada',
      danger: status === 'cancelada',
      warning: status === 'estornada'
    };
  }

  codigoPedidoRelatorio(linha: any) {
    return linha?.pedido?.codigo || linha?.pedidoCodigo || '-';
  }

  nomeArquivoRelatorioExcel() {
    if(this.comissionadoDetalheRelatorio?.nome)
      return `relatorio-comissionamento-${this.comissionadoDetalheRelatorio.nome}.xlsx`;

    return 'relatorio-comissionamento.xlsx';
  }

  exporteRelatorioCsv() {
    const cabecalho = ['Data produção', 'Pedido', this.labelOperacionalSingular(), 'Produto', 'Comissão', 'Qtd', 'Valor fixo', 'Valor calculado', 'Status', 'Motivo estorno', 'Justificativa'];
    const dados = this.modalDetalhesRelatorioAberto ? this.relatorioDetalhadoComissionado() : this.relatorioDetalhado();
    const linhas = [cabecalho, ...dados.map((linha) => [
      this.formateDataCsv(linha.dataProducao),
      linha.pedido?.codigo || linha.pedidoCodigo || '',
      linha.nomeComissionado || '',
      linha.nomeProduto || '',
      linha.nomeComissao || '',
      linha.quantidade || '',
      linha.valorComissaoFixa || '',
      linha.valorCalculado || '',
      linha.status || '',
      linha.motivoEstorno || '',
      linha.justificativaEstorno || ''
    ])];
    const conteudo = linhas.map((linha) => linha.map((valor) => this.escapeCsv(valor)).join(';')).join('\n');
    const blob = new Blob([conteudo], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'relatorio-comissionamento.csv';
    link.click();
    URL.revokeObjectURL(url);
  }

  totalProdutosSelecionados() {
    return Object.keys(this.produtosSelecionados)
      .filter((id) => this.produtosSelecionados[id])
      .filter((id) => this.produtosDoModal().some((produto) => Number(produto.id) === Number(id)))
      .length;
  }

  altereStatusComissao(status: string) {
    this.filtroComissoes.status = status;
    this.carregueComissoes();
  }

  comissoesFiltradas() {
    const busca = String(this.filtroComissoes.busca || '').trim().toLowerCase();
    return (this.comissoes || []).filter((comissao) => {
      if(this.filtroComissoes.status === 'ativas' && !comissao.ativo)
        return false;
      if(this.filtroComissoes.status === 'inativas' && comissao.ativo)
        return false;
      if(busca && String(comissao.nome || '').toLowerCase().indexOf(busca) === -1)
        return false;
      return true;
    });
  }

  comissoesAtivas() {
    return (this.comissoes || []).filter((comissao) => comissao.ativo);
  }

  comissionadosAtivosFiltrados() {
    const busca = String(this.buscaComissionadoRapido || '').trim().toLowerCase();
    return (this.comissionados || [])
      .filter((comissionado) => comissionado.ativo)
      .filter((comissionado) => !busca || String(comissionado.nome || '').toLowerCase().indexOf(busca) !== -1);
  }

  totalComissoesAtivas() {
    return this.comissoesAtivas().length;
  }

  totalComissoesInativas() {
    return (this.comissoes || []).filter((comissao) => !comissao.ativo).length;
  }

  totalComissionadosAtivos() {
    return (this.comissionados || []).filter((comissionado) => comissionado.ativo).length;
  }

  labelOperacionalPlural() {
    return String(this.labelComissionados || '').trim() || 'Comissionados';
  }

  labelOperacionalSingular() {
    const label = this.labelOperacionalPlural();
    return label.endsWith('s') ? label.slice(0, -1) : label;
  }

  totalProdutosVinculados() {
    return (this.produtosResumoComissoes || []).filter((produto) => produto.comissaoId).length;
  }

  totalProdutosDaComissao(comissao: any) {
    if(!comissao?.id)
      return 0;

    return (this.produtosResumoComissoes || []).filter((produto) => Number(produto.comissaoId) === Number(comissao.id)).length;
  }

  totalProdutosDaComissaoSelecionada() {
    return this.totalProdutosDaComissao(this.comissaoSelecionada);
  }

  produtosDoModal() {
    return (this.produtos || []).filter((produto) => {
      if(this.modoProdutos === 'vinculados')
        return this.produtoDaComissaoAtual(produto);

      return !this.produtoDaComissaoAtual(produto);
    });
  }

  produtosSelecionadosDoModal() {
    return Object.keys(this.produtosSelecionados)
      .filter((id) => this.produtosSelecionados[id])
      .map((id) => Number(id))
      .filter((id) => this.produtosDoModal().some((produto) => Number(produto.id) === id));
  }

  produtoDaComissaoAtual(produto: any) {
    return this.comissaoSelecionada?.id && Number(produto?.comissaoId) === Number(this.comissaoSelecionada.id);
  }

  produtoVinculadoOutraComissao(produto: any) {
    return produto?.comissaoId && !this.produtoDaComissaoAtual(produto);
  }

  statusProdutoComissao(produto: any) {
    if(this.produtoDaComissaoAtual(produto))
      return 'Vinculado';
    if(this.produtoVinculadoOutraComissao(produto))
      return 'Outra comissão';
    return 'Disponível';
  }

  nomeCategoriaSelecionada() {
    if(!this.filtroProdutos.categoriaId)
      return 'Todas';

    const categoria = (this.categorias || []).find((item) => Number(item.id) === Number(this.filtroProdutos.categoriaId));
    return categoria?.nome || 'Categoria';
  }

  imagemProduto(produto: any) {
    const linkImagem = produto?.linkImagem;
    if(!linkImagem)
      return null;

    const texto = String(linkImagem);
    if(/^https?:\/\//i.test(texto) || texto.indexOf('/') === 0)
      return texto;

    return `/images/empresa/${texto.replace(/^\/+/, '')}`;
  }

  totalComissoesSemProdutos() {
    return this.comissoesAtivas().filter((comissao) => this.totalProdutosDaComissao(comissao) === 0).length;
  }

  valorMedioComissoesAtivas() {
    const ativas = this.comissoesAtivas();
    if(!ativas.length)
      return 0;

    const total = ativas.reduce((valor, comissao) => valor + Number(comissao.valorFixo || 0), 0);
    return total / ativas.length;
  }

  textoUltimaAtualizacao(comissao: any) {
    const data = comissao?.dataAtualizacao || comissao?.dataAlteracao || comissao?.dataCadastro;
    if(!data)
      return '-';

    return new Date(data).toLocaleDateString('pt-BR');
  }

  private obtenhaCategorias(produtos: any[]) {
    const mapa: any = {};
    produtos.forEach((produto) => {
      if(produto.categoriaId && !mapa[produto.categoriaId])
        mapa[produto.categoriaId] = {id: produto.categoriaId, nome: produto.categoriaNome};
    });
    return Object.keys(mapa).map((id) => mapa[id]).sort((a, b) => a.nome.localeCompare(b.nome));
  }

  private obtenhaCategoriasCatalogo(categorias: any[]) {
    return (categorias || [])
      .filter((categoria) => categoria?.id && categoria?.nome && categoria.removida !== true)
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }

  private removaProdutosVinculadosLocalmente(ids: number[]) {
    const mapaIds = ids.reduce((mapa, id) => {
      mapa[Number(id)] = true;
      return mapa;
    }, {});

    this.produtos = (this.produtos || []).map((produto) => {
      if(!mapaIds[Number(produto.id)])
        return produto;

      return this.limpeComissaoProduto(produto);
    });

    this.produtosResumoComissoes = (this.produtosResumoComissoes || []).map((produto) => {
      if(!mapaIds[Number(produto.id)])
        return produto;

      return this.limpeComissaoProduto(produto);
    });

    ids.forEach((id) => delete this.produtosSelecionados[id]);
  }

  private limpeComissaoProduto(produto: any) {
    return {
      ...produto,
      comissaoId: null,
      comissaoNome: null,
      valorFixo: null,
      comissaoAtiva: null
    };
  }

  private trateErro(erro: any) {
    this.erro = erro;
    this.salvando = false;
    this.carregando = false;
    this.carregandoProdutos = false;
    this.carregandoRelatorio = false;
  }

  private limpeMensagens() {
    this.erro = null;
    this.sucesso = null;
  }

  private escapeCsv(valor: any) {
    const texto = String(valor == null ? '' : valor);
    if(/[;"\n\r]/.test(texto))
      return '"' + texto.replace(/"/g, '""') + '"';
    return texto;
  }

  private formateDataCsv(valor: any) {
    if(!valor)
      return '';
    const data = new Date(valor);
    return data.toLocaleString('pt-BR');
  }

  private apliqueStatusRelatorio() {
    if(this.filtroRelatorio.status === 'canceladas') {
      this.filtroRelatorio.incluirCanceladas = true;
      this.filtroRelatorio.incluirEstornadas = false;
      return;
    }

    if(this.filtroRelatorio.status === 'estornadas') {
      this.filtroRelatorio.incluirCanceladas = false;
      this.filtroRelatorio.incluirEstornadas = true;
      return;
    }

    if(this.filtroRelatorio.status === 'todos') {
      this.filtroRelatorio.incluirCanceladas = true;
      this.filtroRelatorio.incluirEstornadas = true;
      return;
    }

    this.filtroRelatorio.incluirCanceladas = false;
    this.filtroRelatorio.incluirEstornadas = false;
  }

  private relatorioBase() {
    const status = this.filtroRelatorio.status;
    return (this.relatorio || []).filter((item) => {
      if(status === 'canceladas')
        return item.status === 'cancelada';
      if(status === 'estornadas')
        return item.status === 'estornada';
      if(status === 'validas')
        return item.status === 'calculada';
      return true;
    });
  }

  private chaveComissionadoRelatorio(item: any) {
    if(item?.comissionado?.id)
      return `id:${item.comissionado.id}`;

    return `nome:${item?.nomeComissionado || item?.comissionado?.nome || '-'}`;
  }
}
